export default __webpack_public_path__ + "static/media/MilkyNice.e3109e75.ttf";